<div class="image-editor">

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
       <!-- Lựa chọn config hình ảnh trước/sau -->
       <div class="mb-4 mt-2">
        <div class="mb-2" style="line-height: normal">{{'cau_hinh_anh_truoc_sau' | translate}}</div>
        <nz-select [(ngModel)]="selectedImageToConfig">
          <nz-option nzValue="image__before" nzLabel="{{'anh_truoc' | translate }}"></nz-option>
          <nz-option nzValue="image__after" nzLabel="{{'anh_sau' | translate }}"></nz-option>
        </nz-select>
      </div>

      <!-- Phần upload hình ảnh -->
      <app-image-upload-option-config 
        [objectChoosing]="objectChoosing" 
        [setups]="objectChoosing.setups"
        [staticdata]="staticdata" 
        [device]="device" 
        [imageFieldToConfig]="selectedImageToConfig"
        >
      </app-image-upload-option-config>
      
      <app-image-upload-config 
        [objectChoosing]="objectChoosing" 
        [staticdata]="staticdata" 
        [device]="device" 
        [id_subproject]="id_subproject"
        [resolution]="resolution"
        [imageFieldToConfig]="selectedImageToConfig"
        >
      </app-image-upload-config>
    </div>
  </ng-container>
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <!-- Dropdown menu -->
  <div class="editor-content" *ngIf="!isViewAll && configMode == 'advanced'">

    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" 
        [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div *ngIf="!isViewAll">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      
      <!-- HÌNH ẢNH -->
      <li nz-submenu nzTitle="{{'hinh_anh'| translate}}" 
        [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <!-- Lựa chọn config hình ảnh trước/sau -->
        <div class="mb-4 mt-2">
          <div class="mb-2" style="line-height: normal">{{'cau_hinh_anh_truoc_sau' | translate}}</div>
          <nz-select [(ngModel)]="selectedImageToConfig">
            <nz-option nzValue="image__before" nzLabel="{{'anh_truoc' | translate }}"></nz-option>
            <nz-option nzValue="image__after" nzLabel="{{'anh_sau' | translate }}"></nz-option>
          </nz-select>
        </div>

        <!-- Phần upload hình ảnh -->
        <app-image-upload-option-config 
          [objectChoosing]="objectChoosing" 
          [setups]="objectChoosing.setups"
          [staticdata]="staticdata" 
          [device]="device" 
          [imageFieldToConfig]="selectedImageToConfig"
          >
        </app-image-upload-option-config>
        
        <app-image-upload-config 
          [objectChoosing]="objectChoosing" 
          [staticdata]="staticdata" 
          [device]="device" 
          [id_subproject]="id_subproject"
          [resolution]="resolution"
          [imageFieldToConfig]="selectedImageToConfig"
          >
        </app-image-upload-config>
      </li>

      <!-- ÁNH SÁNG VÀ TƯƠNG PHẢN -->
      <li nz-submenu nzTitle="{{'anh_sang_va_tuong_phan'| translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <div class="my-2">
          <div class="mb-3" style="line-height: normal">{{'cau_hinh_anh_truoc_sau' | translate}}</div>
          <nz-select [(ngModel)]="selectedImageToConfigFilter">
            <nz-option nzValue="image__before" nzLabel="{{'anh_truoc' | translate }}"></nz-option>
            <nz-option nzValue="image__after" nzLabel="{{'anh_sau' | translate }}"></nz-option>
          </nz-select>
        </div>
        <app-brightness-contrast-config 
          [elementChoosing]="objectChoosing"
          [id_object]="objectChoosing._id"
          [staticdata]="staticdata"
          [device]="device" 
          [class]="class" 
          [config]="config"
          [filterConfig]="config['filter'][selectedImageToConfigFilter]" 
          [opacityClass]="class[selectedImageToConfigFilter]" >
        </app-brightness-contrast-config>
      </li>

      <!-- KIỂU VIỀN -->
      <li nz-submenu nzTitle="{{'kieu_vien'| translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-borders-config 
          [elementChoosing]="objectChoosing"
          [device]="device" 
          [class]="class" 
          [borderClass]="class['image__container']"
          [id_object]="objectChoosing._id">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="my-4 cursor-pointer" style="float: right">
          <p class="m-0" (click)="openViewAll(style_fields[0])">
            {{ 'mo_rong' | translate }} &#8594;
          </p>
        </div>
      </li>

      <!-- THANH ĐỨNG -->
      <li nz-submenu nzTitle="{{'thanh_dung'| translate}}">
        <ul>
          <li nz-submenu nzTitle="{{'kich_thuoc'| translate}}" 
            [(nzOpen)]="openMap.menu5"
            (nzOpenChange)="openHandler('menu5')">
            <!-- Chiều rộng -->
            <div>
              <div class="config-name">
                <p class="m-0">{{'chieu_rong' | translate}}</p>
                <nz-input-number [nzMin]="1" [nzMax]="100" style="width: 40%" 
                  [ngModel]="class['slider__line']['width'] | vhnumber" 
                  (ngModelChange)="class['slider__line']['width'] = $event + 'px'"
                  (nzBlur)="updateClass()" >
                </nz-input-number>
              </div>
              <div>
                <nz-slider [nzMin]="1" [nzMax]="100" 
                  [ngModel]="class['slider__line']['width'] | vhnumber"
                  (ngModelChange)="class['slider__line']['width'] = $event + 'px'"
                  (nzOnAfterChange)="updateClass()" >
                </nz-slider>
              </div>
            </div>
          </li>
          <!-- Màu nền -->
          <li nz-submenu nzTitle="{{'mau_nen'| translate}}" 
            [(nzOpen)]="openMap.menu6"
            (nzOpenChange)="openHandler('menu6')">
            <div class="config-name">
              <p class="hidden-text">{{'mau_nen' | translate}}</p>
              <div>
                <input class="input-color" type="button"
                  [style.background]="class['slider__line']['background-color']"
                  [cpOKButton]="true" [(colorPicker)]="class['slider__line']['background-color']"
                  (colorPickerClose)="updateClass()" />
              </div>
            </div>
          </li>
          <!-- Viền và bo tròn -->
          <li nz-submenu nzTitle="{{'vien_va_bo_tron'| translate}}" 
            [(nzOpen)]="openMap.menu7"
            (nzOpenChange)="openHandler('menu7')">
            <app-borders-config 
              [elementChoosing]="objectChoosing"
              [device]="device" 
              [class]="class" 
              [borderClass]="class['slider__line']"
              [id_object]="objectChoosing._id">
            </app-borders-config>
            <!-- Nút mở rộng -->
            <div class="my-4 cursor-pointer" style="float: right">
              <p class="m-0" (click)="openViewAll(style_fields[1])">
                {{ 'mo_rong' | translate }} &#8594;
              </p>
            </div>
          </li>
        </ul>
      </li>

      <!-- NÚT KÉO THANH ĐỨNG -->
      <li nz-submenu nzTitle="{{'nut_keo_thanh_dung'| translate}}" >
        <ul>
          <!-- Kiểu nút -->
          <li nz-submenu nzTitle="{{'kieu_nut'| translate}}" 
            [(nzOpen)]="openMap.menu8"
            (nzOpenChange)="openHandler('menu8')">
            <!-- Lựa chọn config kiểu nút -->
            <div class="mb-4">
              <nz-select [(ngModel)]="config['slider-button']['type']" class="mb-4">
                <nz-option nzValue="icon" nzLabel="{{'icon' | translate }}"></nz-option>
                <nz-option nzValue="image" nzLabel="{{'image' | translate }}"></nz-option>
              </nz-select>
              <!-- Icon -->
              <div *ngIf="config['slider-button']['type'] === 'icon'" class="mt-2">
                <div class="mb-4">
                  <div class="mb-3">{{'icon_truoc_sau' | translate}}</div>
                  <nz-select [(ngModel)]="selectedIconToConfigIcon">
                    <nz-option nzValue="icon-before" nzLabel="{{'icon_truoc' | translate }}"></nz-option>
                    <nz-option nzValue="icon-after" nzLabel="{{'icon_sau' | translate }}"></nz-option>
                  </nz-select>
                </div>
                <!-- Chọn icon -->
                <div class="d-flex justify-content-between mb-4">
                  <mat-icon [title]="config['slider-button'][selectedIconToConfigIcon + '-name']">{{ config['slider-button'][selectedIconToConfigIcon + '-name'] }}</mat-icon>
                  <button nz-button nzType="default" (click)="openDialogChooseIcon()" style="border-radius: 5px">
                    Thay đổi
                  </button>
                </div>
                <!-- Màu sắc icon -->
                <div class="config-name mb-4">
                  <p class="hidden-text">{{'mau_sac' | translate}}</p>
                  <div>
                    <input class="input-color" type="button"
                      [style.background]="class['slider__button--' + selectedIconToConfigIcon]['color']"
                      [cpOKButton]="true" [(colorPicker)]="class['slider__button--' + selectedIconToConfigIcon]['color']"
                      (colorPickerClose)="updateClass()" />
                  </div>
                </div>
                <!-- Kích thước icon -->
                <div>
                  <div class="config-name">
                    <p class="m-0">{{'kich_thuoc' | translate}}</p>
                    <nz-input-number [nzMin]="10" [nzMax]="50" style="width: 40%" 
                      [ngModel]="class['slider__button--' + selectedIconToConfigIcon]['font-size'] | vhnumber" 
                      (ngModelChange)="class['slider__button--' + selectedIconToConfigIcon]['font-size'] = $event + 'px'"
                      (nzBlur)="updateClass()" >
                    </nz-input-number>
                  </div>
                  <div>
                    <nz-slider [nzMin]="10" [nzMax]="50" 
                      [ngModel]="class['slider__button--' + selectedIconToConfigIcon]['font-size'] | vhnumber"
                      (ngModelChange)="class['slider__button--' + selectedIconToConfigIcon]['font-size'] = $event + 'px'"
                      (nzOnAfterChange)="updateClass()" >
                    </nz-slider>
                  </div>
                </div>
              </div>
              <!-- Image -->
              <div *ngIf="config['slider-button']['type'] === 'image'">
                <div class="items custom-flex">
                  <label class="mb-1">{{ 'hinh_anh' | translate }}</label>
                  <nz-select [(ngModel)]="config['slider-button']['image-source']" (ngModelChange)="updateConfig()">
                    <nz-option nzValue="upload" [nzLabel]="'tai_anh_len' | translate"></nz-option>
                    <nz-option nzValue="link" [nzLabel]="'duong_dan_hinh_anh' | translate"></nz-option>
                    <nz-option nzValue="library" [nzLabel]="'chon_tu_thu_vien' | translate"></nz-option>
                  </nz-select>
                </div>
                <div class="item mt-2" *ngIf="config['slider-button']['image-source'] == 'upload'">
                  <input type="file" (change)="onUploadSliderButton($event)" id="uploadSliderButton" style="opacity: 0; display: none" />
                  <button style="width: 100%; margin-top: 5px;"  
                    (click)="openUploadSliderButton()"
                    nz-button nzType="primary">
                    {{'tai_anh_len' | translate}}
                  </button>
                </div>
                <div class="w-mat-input mt-2" *ngIf="config['slider-button']['image-source'] == 'link'">
                  <div class="mt-3 mb-1">
                    <mat-label class="title">{{'su_dung_duong_dan_hinh_anh' | translate}}</mat-label>
                  </div>
                  <div>
                    <textarea rows="4" nz-input [(ngModel)]="config['slider-button']['image-src']"
                      (change)="updateConfig()"></textarea>
                  </div>
                </div>
                <div class="item mt-2" *ngIf="config['slider-button']['image-source'] == 'library'">
                  <button (click)="openLibrary()">
                    <i class="bi bi-plus-circle"></i> {{'chon_anh_tu_thu_vien' | translate}}
                  </button>
                </div>
              </div>
            </div>
          </li>
          <!-- Kích thước -->
          <li nz-submenu nzTitle="{{'kich_thuoc'| translate}}" 
            [(nzOpen)]="openMap.menu9"
            (nzOpenChange)="openHandler('menu9')">
            <!-- Chiều ngang -->
            <div>
              <div class="config-name">
                <p class="m-0">{{'chieu_ngang' | translate}}</p>
                <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%" 
                  [ngModel]="class['slider__button']['width'] | vhnumber" 
                  (ngModelChange)="class['slider__button']['width'] = $event + 'px'"
                  (nzBlur)="updateClass()" >
                </nz-input-number>
              </div>
              <div>
                <nz-slider [nzMin]="10" [nzMax]="100" 
                  [ngModel]="class['slider__button']['width'] | vhnumber"
                  (ngModelChange)="class['slider__button']['width'] = $event + 'px'"
                  (nzOnAfterChange)="updateClass()" >
                </nz-slider>
              </div>
            </div>
            <!-- Chiều cao -->
            <div>
              <div class="config-name">
                <p class="m-0">{{'chieu_cao' | translate}}</p>
                <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%" 
                  [ngModel]="class['slider__button']['height'] | vhnumber" 
                  (ngModelChange)="class['slider__button']['height'] = $event + 'px'"
                  (nzBlur)="updateClass()" >
                </nz-input-number>
              </div>
              <div>
                <nz-slider [nzMin]="10" [nzMax]="100" 
                  [ngModel]="class['slider__button']['height'] | vhnumber"
                  (ngModelChange)="class['slider__button']['height'] = $event + 'px'"
                  (nzOnAfterChange)="updateClass()" >
                </nz-slider>
              </div>
            </div>
          </li>
          <!-- Màu nền -->
          <li nz-submenu nzTitle="{{'mau_nen'| translate}}" 
            [(nzOpen)]="openMap.menu10"
            (nzOpenChange)="openHandler('menu10')">
            <div class="config-name">
              <p class="hidden-text">{{'mau_nen' | translate}}</p>
              <div>
                <input class="input-color" type="button"
                  [style.background]="class['slider__button']['background-color']"
                  [cpOKButton]="true" [(colorPicker)]="class['slider__button']['background-color']"
                  (colorPickerClose)="updateClass()" />
              </div>
            </div>
          </li>
          <!-- Viền và bo tròn -->
          <li nz-submenu nzTitle="{{'vien_va_bo_tron'| translate}}" 
            [(nzOpen)]="openMap.menu11"
            (nzOpenChange)="openHandler('menu11')">
            <app-borders-config 
              [elementChoosing]="objectChoosing"
              [device]="device" 
              [class]="class" 
              [borderClass]="class['slider__button']"
              [id_object]="objectChoosing._id">
            </app-borders-config>
            <!-- Nút mở rộng -->
            <div class="my-4 cursor-pointer" style="float: right">
              <p class="m-0" (click)="openViewAll(style_fields[2])">
                {{ 'mo_rong' | translate }} &#8594;
              </p>
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </div>

  <!-- MỞ RỘNG -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Bo tròn viền image__container -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config 
        [elementChoosing]="objectChoosing"
        [borderRadiusClass]="class['image__container']"
        [device]="device" 
        [class]="class" 
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
    <!-- Bo tròn viền slider__line -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config 
        [elementChoosing]="objectChoosing"
        [borderRadiusClass]="class['slider__line']"
        [device]="device" 
        [class]="class" 
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
    <!-- Bo tròn viền slider__button -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <app-borders-radius-config 
        [elementChoosing]="objectChoosing"
        [borderRadiusClass]="class['slider__button']"
        [device]="device" 
        [class]="class" 
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>
